import React from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "../../../../../components/Dropdown";
import { VALIDATION_FIELD_MAPPING } from "../../../../../utils/appConstant";

interface HeaderProps {
  filters: any;
  dropdownSearchData: any;
  months: any[];
  allMonths: any[];
  yearLookup: any[];
  onSearch: (e: any, name: string) => void;
  onChange: (e: any, name: string) => void;
}

const Header: React.FC<HeaderProps> = ({
  filters,
  dropdownSearchData,
  months,
  allMonths,
  yearLookup,
  onSearch,
  onChange
}) => {
  const { t } = useTranslation();

  return (
    <div className="row mb-6">
      <div className="col-sm-6">
        <h4 className="m-0 fw-bold">{t("layout.pageTexts.dashboard.pageTexts.header.title")}</h4>
        <p>{t("layout.pageTexts.dashboard.pageTexts.header.subTitle")}</p>
      </div>
      <div className="col-sm-6 d-flex justify-content-end align-items-center gap-2">
      </div>
    </div>
  );
}

export default Header;